import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { ObjectType } from '@/@types/graphql-types';
import PictureComp from '@/components/picture/PictureComp.vue';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';
import OffersDisplay from '@/components/streaming-charts/OffersDisplay.vue';
import { useI18n } from '@/helpers/composables/useI18n';

import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { ShareMethod } from '@/enums/share-methods';
import { addToast } from '@/helpers/toast/toast-helper';
import { getVm } from '@/helpers/vm-helper';
import { getShareUrl } from '@/helpers/share-helper';
import type { StreamingChartTitle } from './types';
import { ClassicUrl, safeOpen } from '@/helpers/clickout-helper';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartsListItem',
  props: {
    title: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
	title: StreamingChartTitle;
	index: number;
};



const expandRow = ref(false);
const toggleRow = () => {
	expandRow.value = !expandRow.value;
};

const posterUrl = computed(() => JW_CONFIG.IMAGESCALER_URL + props.title.node.content.fullPosterUrl);

const getTitleName = (title: StreamingChartTitle) => {
	if (title.node.objectType === ObjectType.ShowSeason) {
		// @ts-ignore
		return title?.node?.show?.content?.title;
	}
	return title?.node?.content?.title;
};

const { t, tc } = useI18n();
function getSeasonNumber(title: StreamingChartTitle) {
	// @ts-ignore
	return `${t('WEBAPP_SEASON')} ${title?.node?.content?.seasonNumber}`;
}

function numberOfDays(days: number | undefined) {
	if (!days) return '--';
	return days === 1 ? `${days} ${tc('WEBAPP_DAY')}` : t('WEBAPP_X_DAYS', { number: days });
}

function padNumber(number: number | undefined) {
	return number?.toString().padStart(2, '0') ?? number;
}

function share(
	titleDetails: { titleId: number; titleObjectType: ObjectType; titleFullPath: string; titleName: string },
	method?: ShareMethod
) {
	const shareUrl = getShareUrl(titleDetails.titleFullPath);
	const shareText = `${titleDetails.titleName}:`;

	switch (method) {
		case ShareMethod.FACEBOOK:
			safeOpen(
				new ClassicUrl('http://www.facebook.com/sharer/sharer.php').set('u', shareUrl).set('t', shareText)
			);
			break;
		case ShareMethod.TWITTER:
			safeOpen(new ClassicUrl('https://twitter.com/intent/tweet').set('url', shareUrl).set('text', shareText));
			break;
		default:
			if (navigator && navigator.clipboard) {
				navigator.clipboard.writeText(shareUrl);
				addToast({ message: getVm().$t('WEBAPP_COPIED_TO_CLIPBOARD') });
			}
	}
}

return { __sfc: true,props, expandRow, toggleRow, posterUrl, getTitleName, t, tc, getSeasonNumber, numberOfDays, padNumber, share, PictureComp, SingleRankingDisplay, OffersDisplay, faTwitter, faFacebook, faCopy, ShareMethod, faChevronDown, faChevronUp }
}

})